import {
    localSave,
    localRead
} from './lang';
import i18n from '@/plugins/i18n';
import Api from "@/services/endpoint/tenant.service";
import moment from "moment";
import store from '@/store/main.js';
import axios from 'axios';
import config from '@/configure/index'
import { authRead } from '@/store/auth.js';
import WebSocket from "isomorphic-ws";
import Cookies from "js-cookie";

let apiBaseUrl = config.apiBaseUrl;
let token = authRead();
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export const cancel = async(orderId, payload) => {
    return await Api.Order.putCancleOrder(orderId, payload);
};

export const confirmCod = async(payload) => {
    try {
        const resp = await Api.OrderV2.postBatchConfirmCod(payload);
        if(![200, 201].includes(resp.status)){
          throw resp
        }
        return resp.data;
    } catch (err) {
      console.log('confirmCod err',err); 
        let data = {
            'status': false,
            'statusCode':err.status,
            'message': err.response? err.response.data.message: err,
        }
        
        return data;
    }
};

export default {
    state: {
        local: localRead('local'),
    },
    mutations: {
        setLocal(state, lang) {
            localSave('local', lang);
            state.local = lang;
        },
        vueTableFormatJson(restData) {
            let jsonData = restData.data;
            let data = [];
            for (let [k, v] of Object.entries(jsonData)) {
                switch (k) {
                    case 'links':
                        let link = []
                        for (let [kLink, vLink] of Object.entries(v)) {
                            link[kLink + '_page_url'] = vLink
                        }
                        data = {...data, ...link };
                        break;
                    case 'meta':
                        data = {...data, ...v };
                        break;
                    case 'data':
                        data = {...data, ... { data: v } };
                        break;
                    default:
                        data[k] = {...data[k], ...v };
                }
            }
            return data;
        }
    },
    getNumberFormatCurrency(number){
      return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(number)
    },
    getImage(fileName) {
        var image = require('@/assets/images/no-image.png');
        try {
            image = '<img src="' + this.getImageSrc(fileName) + '" width="24">';
        } catch (error) {
            console.log(error, 'error');
        }
        return image;
    },
    getImageSrc(fileName, extension = '.png') {
        let images = require('@/assets/images/no-image.png');
        try {
            images = require('@/assets/images/' + fileName + extension);
            // images = require('@/assets/images/COD.png');
        } catch (err) {}
        return images
    },
    getImageGobalAssets(fileName) {
        let images = require('@/assets/images/no-image.png');
        try {
            images = require('@/assets/global_assets/images/' + fileName + '.png');
            // console.log(images, "---------------------------------Success Image");
        } catch (err) {
            // console.log(err, "---------------------------------Error Image");
        }
        return images

    },
    getImageUser(fileName) {
        let images = require('@/assets/images/no-image-user.png');
        try {
            images = require('@/assets/global_assets/images/' + fileName + '.png');
            // console.log(images, "---------------------------------Success Image");
        } catch (err) {
            // console.log(err, "---------------------------------Error Image");
        }
        return images

    },
    isset(accessor) {
        try {
            // Note we're se
            return typeof accessor() !== 'undefined'
        } catch (e) {
            return false
        }
    },
    issetObjectKey(setDefault,param,key,digits = 0, turnBoolean = false) {
      let trunData = setDefault;
      if(param) {
        if(
          Object.keys(param).includes(key) && param[key] ||
          Object.keys(param).includes(key) && !isNaN(parseFloat(param[key]))
        ) {
          if(turnBoolean) {
            trunData = (param[key] || param[key].toString() == '1') ? true : false;
          } else {
            trunData = !isNaN(parseFloat(param[key])) ? Number(parseFloat(param[key]).toFixed(digits)) : param[key];
          }
        }
      }
      return trunData;
    },
    monthNames() {
        return [i18n.t("Jan"), i18n.t("Feb"), i18n.t("Mar"), i18n.t("Apr"), i18n.t("May"), i18n.t("Jun"), i18n.t("Jul"), i18n.t("Aug"), i18n.t("Sep"), i18n.t("Oct"), i18n.t("Nov"), i18n.t("Dec"), i18n.t("January"), i18n.t("February"), i18n.t("March"), i18n.t("April"), i18n.t("May"), i18n.t("June"), i18n.t("July"), i18n.t("August"), i18n.t("September"), i18n.t("October"), i18n.t("November"), i18n.t("December")].slice(0, 12);
    },

    daysOfWeek() {
        return [i18n.t("Sun"), i18n.t("Mon"), i18n.t("Tue"), i18n.t("Wed"), i18n.t("Thu"), i18n.t("Fri"), i18n.t("Sat"), i18n.t("Sunday"), i18n.t("Monday"), i18n.t("Tuesday"), i18n.t("Wednesday"), i18n.t("Thursday"), i18n.t("Friday"), i18n.t("Saturday")].slice(0, 7).map((function(t) {
            return t.substring(0, 2)
        }))
    },
    singleRanges(date = null) {
      try{
        let today = new Date();
        let todayEnd = new Date();
        if(date != null){
          today = new Date(date.startDate);
          if(date.endDate == null){
            todayEnd = new Date(date.startDate);
          }else{
            todayEnd = new Date(date.endDate);
          }
        }

        today = new Date(today);
        todayEnd = new Date(todayEnd);
        let minutes5BeforeStart = new Date(today)
        let minutes5BeforeEnd = new Date(todayEnd)
        let minutes10BeforeStart = new Date(today)
        let minutes10BeforeEnd = new Date(todayEnd)
        let minutes15BeforeStart = new Date(today)
        let minutes15BeforeEnd = new Date(todayEnd)
        let minutes30BeforeStart = new Date(today)
        let minutes30BeforeEnd = new Date(todayEnd)
        let hours1BeforeStart = new Date(today)
        let hours1BeforeEnd = new Date(todayEnd)
        let hours2BeforeStart = new Date(today)
        let hours2BeforeEnd = new Date(todayEnd)
        let yesterdayStart = new Date(today)
        let yesterdayEnd = new Date(todayEnd)
        let twoDaysAgoStart = new Date(today)
        let twoDaysAgoEnd = new Date(todayEnd)

        today.setHours(today.getHours());
        todayEnd.setHours(todayEnd.getHours());

        minutes5BeforeStart.setHours(today.getHours());
        minutes5BeforeStart.setMinutes(today.getMinutes() - 5);
        minutes5BeforeStart.setSeconds(today.getSeconds());

        minutes5BeforeEnd.setHours(todayEnd.getHours());
        minutes5BeforeEnd.setMinutes(todayEnd.getMinutes() - 5);
        minutes5BeforeEnd.setSeconds(todayEnd.getSeconds());

        minutes10BeforeStart.setHours(today.getHours());
        minutes10BeforeStart.setMinutes(today.getMinutes() - 10);
        minutes10BeforeStart.setSeconds(today.getSeconds());
        minutes10BeforeStart.setMilliseconds(today.getMilliseconds());

        minutes10BeforeEnd.setHours(todayEnd.getHours());
        minutes10BeforeEnd.setMinutes(todayEnd.getMinutes() - 10);
        minutes10BeforeEnd.setSeconds(todayEnd.getSeconds());
        minutes10BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

        minutes15BeforeStart.setHours(today.getHours());
        minutes15BeforeStart.setMinutes(today.getMinutes() - 15);
        minutes15BeforeStart.setSeconds(today.getSeconds());
        minutes15BeforeStart.setMilliseconds(today.getMilliseconds());

        minutes15BeforeEnd.setHours(todayEnd.getHours());
        minutes15BeforeEnd.setMinutes(todayEnd.getMinutes() - 15);
        minutes15BeforeEnd.setSeconds(todayEnd.getSeconds());
        minutes15BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

        minutes30BeforeStart.setHours(today.getHours());
        minutes30BeforeStart.setMinutes(today.getMinutes() - 30);
        minutes30BeforeStart.setSeconds(today.getSeconds());
        minutes30BeforeStart.setMilliseconds(today.getMilliseconds());

        minutes30BeforeEnd.setHours(todayEnd.getHours());
        minutes30BeforeEnd.setMinutes(todayEnd.getMinutes() - 30);
        minutes30BeforeEnd.setSeconds(todayEnd.getSeconds());
        minutes30BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

        hours1BeforeStart.setHours(today.getHours() - 1);
        hours1BeforeStart.setMinutes(today.getMinutes());
        hours1BeforeStart.setSeconds(today.getSeconds());
        hours1BeforeStart.setMilliseconds(today.getMilliseconds());

        hours1BeforeEnd.setHours(todayEnd.getHours() - 1);
        hours1BeforeEnd.setMinutes(todayEnd.getMinutes());
        hours1BeforeEnd.setSeconds(todayEnd.getSeconds());
        hours1BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

        hours2BeforeStart.setHours(today.getHours() - 2);
        hours2BeforeStart.setMinutes(today.getMinutes());
        hours2BeforeStart.setSeconds(today.getSeconds());
        hours2BeforeStart.setMilliseconds(today.getMilliseconds());

        hours2BeforeEnd.setHours(todayEnd.getHours() - 2);
        hours2BeforeEnd.setMinutes(todayEnd.getMinutes());
        hours2BeforeEnd.setSeconds(todayEnd.getSeconds());
        hours2BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

        yesterdayStart.setDate(today.getDate() - 1)
        yesterdayStart.setHours(today.getHours());

        yesterdayEnd.setDate(today.getDate() - 1)
        yesterdayEnd.setHours(today.getHours());

        twoDaysAgoStart.setDate(today.getDate() - 2)
        twoDaysAgoStart.setHours(today.getHours());

        twoDaysAgoEnd.setDate(today.getDate() - 2)
        twoDaysAgoEnd.setHours(today.getHours());

        const defaultRanges = {
            'At time of event':   [today, todayEnd],
            '5 minutes before':   [minutes5BeforeStart, minutes5BeforeEnd],
            '10 minutes before':  [minutes10BeforeStart, minutes10BeforeStart],
            '15 minutes before':  [minutes15BeforeStart, minutes15BeforeStart],
            '30 minutes before':  [minutes30BeforeStart, minutes30BeforeStart],
            '1 hour before':      [hours1BeforeStart, hours1BeforeStart],
            '2 hour before':      [hours2BeforeStart, hours2BeforeEnd],
            '1 day before':       [yesterdayStart, yesterdayEnd],
            '2 day before':       [twoDaysAgoStart, twoDaysAgoEnd],
        }

        let _ranges = [];
        for (const [key, value] of Object.entries(defaultRanges)) {
            _ranges[i18n.t(key)] = value;
        }
        return Object.assign({}, _ranges);

      } catch (error) {
        console.log("error",error)
      }
    },
    ranges(rengesFilter=[]) {
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        let todayEnd = new Date()
        // todayEnd.setHours(11, 59, 59, 999);
        todayEnd.setHours(23, 59, 59, 999);

        let yesterdayStart = new Date()
        yesterdayStart.setDate(today.getDate() - 1)
        yesterdayStart.setHours(0, 0, 0, 0);

        let yesterdayEnd = new Date()
        yesterdayEnd.setDate(today.getDate() - 1)
        yesterdayEnd.setHours(23, 59, 59, 999);

        let last30DaysStart = new Date()
        last30DaysStart.setDate(today.getDate() - 29)
        last30DaysStart.setHours(0, 0, 0, 0);

        let last30DaysEnd = new Date()
        last30DaysEnd.setDate(today.getDate())
        last30DaysEnd.setHours(23, 59, 59, 999);

        let last7DaysStart = new Date()
        last7DaysStart.setDate(today.getDate() - 6)
        last7DaysStart.setHours(0, 0, 0, 0);

        let last7DaysEnd = new Date()
        last7DaysEnd.setDate(today.getDate())
        last7DaysEnd.setHours(23, 59, 59, 999);

        let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        // let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);
        let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999);

        let defaultRanges = {};
        if(rengesFilter.length > 0){
          rengesFilter.forEach(key => {
            switch (key) {
              case 'Today':
                let toDay = { '_Dashboard.Today': [today, todayEnd] };
                Object.assign(defaultRanges, toDay);
                break;
              case 'Yesterday':
                let yesterday = { '_Dashboard.Yesterday': [yesterdayStart, yesterdayEnd] };
                Object.assign(defaultRanges, yesterday);
                break;
              case 'Last 7 Days':
                let last7Days = { '_Dashboard.Last 7 Days': [last7DaysStart, last7DaysEnd] };
                Object.assign(defaultRanges, last7Days);
                break;
              case 'Last 30 Days':
                let last30Days = { '_Dashboard.Last 30 Days': [last30DaysStart, last30DaysEnd] };
                Object.assign(defaultRanges, last30Days);
                break;
              case 'This Month':
                let thisMonth = { '_Dashboard.This Month': [thisMonthStart, thisMonthEnd] };
                Object.assign(defaultRanges, thisMonth);
                break;
              case 'Last Month':
                let lastMonth = { '_Dashboard.Last Month': [
                  new Date(today.getFullYear(), today.getMonth() - 1, 1),
                  // new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
                  new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999)
                ], };
                Object.assign(defaultRanges, lastMonth);
                break;
              case 'Last 6 Months':
                let last6Months = { '_Dashboard.Last 6 Months': [
                  new Date(today.getFullYear(), today.getMonth(), today.getDate() - 180, 0),
                  new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)
                ], };
                Object.assign(defaultRanges, last6Months);
                break;
              case 'This Year':
                let thisYear = { '_Dashboard.This Year': [
                  new Date(today.getFullYear(), 0, 1),
                  // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
                  new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
                ], };
                Object.assign(defaultRanges, thisYear);
                break;
              case 'Year':
                let year = { '_Dashboard.Year': [
                  new Date(today.getFullYear() -5, 0, 1),
                  // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
                  new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
                ], };
                Object.assign(defaultRanges, year);
                break;
              default:
                break;
            }
          });
        }else{
          defaultRanges = {
            'Today': [today, todayEnd],
            'Yesterday': [yesterdayStart, yesterdayEnd],
            'This month': [thisMonthStart, thisMonthEnd],
            'This year': [
              new Date(today.getFullYear(), 0, 1),
              // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
              new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            ],
            'Last month': [
              new Date(today.getFullYear(), today.getMonth() - 1, 1),
              // new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
              new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999)
            ],
            '_Dashboard.Last 6 Months': [
              // new Date(today.getFullYear(), today.getMonth() - 6, 1),
              // new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999)
              new Date(today.getFullYear(), today.getMonth(), today.getDate() - 180, 0),
              new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)
            ],
          }
        }

        let _ranges = [];
        for (const [key, value] of Object.entries(defaultRanges)) {
            _ranges[i18n.t(key)] = value;
        }
        return Object.assign({}, _ranges);

    },
    getCarrierCode(integrationTypeId) {
        var carrierCode = '';
        switch (integrationTypeId.toString()) {
            case '4':
              carrierCode = 'KERRY_EXPRESS';
                break;
            // case '4':
            //   carrierCode = 'KEX';
            //     break;
            case '5':
              carrierCode = 'THAIPOST';
                break;
            case '6':
                carrierCode = 'FLASH_EXPRESS';
                break;
            case '8':
              carrierCode = 'J&T_EXPRESS';
                break;
            default:
              carrierCode = '-';
                break;
        }
        return carrierCode;
    },
    updatedSummary(order, discountType = 1) {
      var newOrder = order;
      var subTotal = 0;
      var total = 0;
      var shippingPrice = this.issetObjectKey(0, order, 'shipping_price', 4);
      var codPrice = this.issetObjectKey(0, order, 'cod_price', 4);
      var discount = this.issetObjectKey(0, order, 'discount', 4);
      var discountPercentage = this.issetObjectKey(0, order, 'discount_percentage', 4);
      // items ============================================================================
      var itemsList = this.issetObjectKey([], order, 'items').length > 0 ?
                        this.issetObjectKey([], order, 'items')
                        : this.issetObjectKey([], order, 'sales_order_item');
      itemsList.forEach((element) => {
        let isDelete = this.issetObjectKey(false, element, 'is_delete', 0, true);
        let promotionGroupId = this.issetObjectKey(null, element, 'promotion_group_id');
        let promotionId = this.issetObjectKey(this.issetObjectKey(null, element, 'sales_order_promotion_id'), element, 'promotion_id');
        if(promotionGroupId == null && promotionId == null && isDelete == false) {
          subTotal += this.issetObjectKey(0, element, 'total', 4);
        }
      });
      // promotion ========================================================================
      var itemsPromotion = this.issetObjectKey([], order, 'items_promotion').length > 0 ?
                            this.issetObjectKey([], order, 'items_promotion')
                            : this.issetObjectKey([], order, 'sales_order_promotion');
      itemsPromotion.forEach((element) => {
        subTotal += (this.issetObjectKey(0, element, 'discounted_price', 4) * this.issetObjectKey(0, element, 'ordered_quantity', 4));
      });
      // upsell ===========================================================================
      var itemsUpsell = this.issetObjectKey([], order, 'items_upsell');
      itemsUpsell.forEach((element) => {
        subTotal += this.issetObjectKey(0, element, 'total', 4);
      });

      if(discountType == 2){
        discount = parseFloat(discountPercentage) * parseFloat(subTotal) / 100;
        newOrder.discount = discount;
      }

      if(discount <= subTotal){
        total = parseFloat(subTotal) + parseFloat(shippingPrice) + parseFloat(codPrice) - parseFloat(discount);
      }else{
        total = parseFloat(subTotal) + parseFloat(shippingPrice) + parseFloat(codPrice)
      }

      newOrder.sub_total = subTotal;
      newOrder.shipping_price_before_vat = shippingPrice;
      newOrder.discount_before_vat = discount;
      newOrder.cod_price_before_vat = codPrice;
      newOrder.total_before_vat = total.toFixed(2);
      newOrder.total = total.toFixed(2);
      if(discount > subTotal){
        newOrder.discount = 0;
      }
      return newOrder;
    },
    orderCalculate(order, setting, upsell = '') {
      var newOrder = order;
      var totalVat = 0;
      var totalBeforeVat = 0;
      var subTotal = 0;

      var discountFormat = '';
      var codPriceFormate = '';
      var shippingPriceFormate = '';

      var discountInclude = 0;
      var discountExclude = 0;

      var subTotalInclude = 0;
      var subTotalExclude = 0;

      var vatOnProduct = false;
      var vatOnShipping = false;
      var vatOnCod = false;
      var invoiceDiscountType = 'average';

      if(
        (order.data && order.data.vat_on_product == 1) ||
        (
          setting.vat_on_product == 1 && 
          (
            !order.data || 
            (order.data && !order.data.vat_on_product == 1)
          )
        )
      ){
        vatOnProduct = true;
      }

      if(
        (order.data && order.data.vat_on_shipping == 1) ||
        (
          setting.vat_on_shipping == 1 && 
          (
            !order.data || 
            (order.data && !order.data.vat_on_shipping == 1)
          )
          
        )
      ){
        vatOnShipping = true;
      }

      if(
        (order.data && order.data.vat_on_cod_service == 1) ||
        (
          setting.vat_on_cod_service == 1 && 
          (
            !order.data ||
            (order.data && !order.data.vat_on_cod_service == 1)
          )
        )
      ){
        vatOnCod = true;
      }

      if(order.data && order.data.invoice_discount_type) {
        invoiceDiscountType = order.data.invoice_discount_type;
      }else if(
          setting.invoice_discount_type && 
          (
            !order.data ||
            (order.data && !order.data.invoice_discount_type)
          )
      ){
        invoiceDiscountType = setting.invoice_discount_type;
      }

      // order discount
      if(isNaN(parseFloat(order.discount))){
        order.discount = 0;
      }
      if (order.discount == '.') {
        order.discount = order.discount.toString().replace(/^./g, '')
      }
      if (order.discount <= order.sub_total) {
        if (order.discount < 1) {
          discountFormat = order.discount;
        } else {
          discountFormat = order.discount.toString().replace(/^0+/, "");
        }
      } else {
        order.discount = 0;
      }
      
      order.discount = discountFormat ? discountFormat : 0;
      order.discount_final =  order.discount ? parseFloat(order.discount) : 0;

      var orderDiscount = discountFormat;
      
      if(invoiceDiscountType == 'include'){
        discountInclude = discountFormat
      }
      if(invoiceDiscountType == 'exempt'){
        discountExclude = discountFormat
      }

      let sumSubTotalUpSellItems = order.items_upsell && order.items_upsell.length ? order.items_upsell.map(item => parseFloat(item.total)).reduce((prev, next) => prev + next, 0) : 0;
      let sumSubTotalItems = order.items.map(item => parseFloat(item.total)).reduce((prev, next) => prev + next, 0);
      let sumAllSubTotal = parseFloat(sumSubTotalUpSellItems) + parseFloat(sumSubTotalItems);

      if (order.items_upsell && order.items_upsell.length) {
        order.items_upsell.forEach(element => {

          element['discount'] = element.discount ? element.discount : 0;
          let averageOrderDiscount = 0;
          let elementTotal = element.total;

          if(invoiceDiscountType == 'average' && orderDiscount > 0 ){
            averageOrderDiscount = (parseFloat(orderDiscount) * parseFloat(elementTotal)) / parseFloat(sumAllSubTotal);
            elementTotal = parseFloat(elementTotal) - parseFloat(averageOrderDiscount)
          }

          if (!element['discount_before_vat']) {
            element['discount_before_vat'] = 0;
          }
          if (vatOnProduct){
            if (element.is_vat == 1 || element.total_vat > 0) {

              element['is_vat'] = 1;
              element['price_vat'] = (parseFloat(element.price) * 7) / 107;
              element['sub_total_vat'] = (parseFloat(element.sub_total) * 7) / 107;
              element['discount_vat'] = (parseFloat(element.discount) * 7) / 107;
              element['total_vat'] = (parseFloat(elementTotal) * 7) / 107;
              element['price_before_vat'] = parseFloat(element.price) - parseFloat(element.price_vat);
              element['sub_total_before_vat'] = parseFloat(element.sub_total) - parseFloat(element.sub_total_vat);
              element['discount_before_vat'] = parseFloat(element.discount) - parseFloat(element.discount_vat ? element.discount_vat : 0);
              element['total_before_vat'] = parseFloat(elementTotal) - parseFloat(element.total_vat);
              subTotal += parseFloat(elementTotal);

              discountInclude = parseFloat(discountInclude) + parseFloat(averageOrderDiscount);              
              subTotalInclude = parseFloat(subTotalInclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
            } else {
              discountExclude = parseFloat(discountExclude) + parseFloat(averageOrderDiscount);
              subTotalExclude = parseFloat(subTotalExclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
            }
          } else {
            discountExclude = parseFloat(discountExclude) + parseFloat(averageOrderDiscount);
            subTotalExclude = parseFloat(subTotalExclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
          }
        });
      }

      order.items.forEach(element => {
        let discountItemFormate = '';
        if (element.discount < 1) {
          if (element.discount == '.') {
            element.discount = element.discount.toString().replace(/^./g, '')
          }
          discountItemFormate = element.discount;
        } else {
          discountItemFormate = element.discount.toString().replace(/^0+/, "");
        }
        element['discount'] = discountItemFormate ? discountItemFormate : '';
        let elementDiscountFinal = element['discount'] ? parseFloat(element['discount']) : 0;
        let averageOrderDiscount = 0;
        let elementTotal = element.total;

        if(invoiceDiscountType == 'average' && orderDiscount > 0 ){
          averageOrderDiscount = (parseFloat(orderDiscount) * parseFloat(elementTotal)) / parseFloat(sumAllSubTotal);
          elementTotal = parseFloat(elementTotal) - parseFloat(averageOrderDiscount)
        }
        
        if (vatOnProduct) { //Store product vat
          element.promotion_group_id = this.isset(() => element.promotion_group_id) ? element.promotion_group_id : null;

          element['total_before_vat'] = 0; //default for item no vat

          if (
              element.status == 1 && 
              (
                element.is_vat == 1 || parseFloat(element.total_vat) > 0 || 
                (element['product'] && element['product'].is_vat) || 
                  element.promotion_group_id
              )
          ) {
            
            element['is_vat'] = 1;
            element['price_vat'] = (parseFloat(element.price) * 7) / 107;
            element['sub_total_vat'] = (parseFloat(element.sub_total) * 7) / 107;
            element['discount_vat'] = (parseFloat(elementDiscountFinal) * 7) / 107;
            element['total_vat'] = (parseFloat(elementTotal) * 7) / 107;
            element['price_before_vat'] = parseFloat(element.price) - parseFloat(element.price_vat);
            element['sub_total_before_vat'] = parseFloat(element.sub_total) - parseFloat(element.sub_total_vat);
            element['discount_before_vat'] = parseFloat(elementDiscountFinal) - parseFloat(element.discount_vat);

            element['total_before_vat'] = parseFloat(elementTotal) - parseFloat(element['total_vat']);
            
            if(parseFloat(element.total_vat) <= 0) {
              element['total_before_vat'] = 0;
            }
            subTotal += parseFloat(elementTotal);

            discountInclude = parseFloat(discountInclude) + parseFloat(averageOrderDiscount);
            subTotalInclude = parseFloat(subTotalInclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
          } else {
            discountExclude = parseFloat(discountExclude) + parseFloat(averageOrderDiscount);
            subTotalExclude = parseFloat(subTotalExclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
          }
        } else {
          discountExclude = parseFloat(discountExclude) + parseFloat(averageOrderDiscount);
          subTotalExclude = parseFloat(subTotalExclude) + parseFloat(invoiceDiscountType === 'average' ? element.total : elementTotal);
        }
      });

      if (subTotal > 0) {
        totalVat += (subTotal * 7) / 107;
        totalBeforeVat = subTotal;
      }
      
      // check shipping_price
      if (order.shipping_price == '.') {
        order.shipping_price = order.shipping_price.toString().replace(/^./g, '')
        order.shipping_price = order.shipping_price.toString();
      }
      if (order.shipping_price < 1) {
        shippingPriceFormate = order.shipping_price;
      } else {
        shippingPriceFormate = order.shipping_price.toString().replace(/^0+/, "");
      }
      order.shipping_price = shippingPriceFormate ? shippingPriceFormate : '';
      order.shipping_price_final = order.shipping_price ? parseFloat(order.shipping_price) : 0;

      //cal shipping price vat
      if (vatOnShipping) {
        var shippingPrice = order.shipping_price_final;

        newOrder.shipping_price_vat = (shippingPrice * 7) / 107;
        newOrder.shipping_price_before_vat = shippingPrice - parseFloat(newOrder.shipping_price_vat);
        newOrder.shipping_price = order.shipping_price;
        totalVat += (parseFloat(shippingPrice) * 7) / 107;
        totalBeforeVat += parseFloat(shippingPrice);
        subTotalInclude += parseFloat(shippingPrice);
      } else {
        subTotalExclude += parseFloat(order.shipping_price_final);
      }

      // check cod_price
      if (order.cod_price == '.') {
        order.cod_price = order.cod_price.toString().replace(/^./g, '')
      }
      if (order.cod_price < 1) {
        codPriceFormate = order.cod_price;
      } else {
        codPriceFormate = order.cod_price.toString().replace(/^0+/, "");
      }
      order.cod_price = codPriceFormate ? codPriceFormate : '';
      order.cod_price_final = order.cod_price ? parseFloat(order.cod_price) : 0;

      // cal cod price vat
      if (vatOnCod) {
        var codPrice = order.cod_price_final;

        newOrder.cod_price_vat = (parseFloat(codPrice) * 7 / 107);
        newOrder.cod_price_before_vat = parseFloat(codPrice) - parseFloat(newOrder.cod_price_vat);
        totalVat += (parseFloat(codPrice) * 7) / 107;
        totalBeforeVat += parseFloat(codPrice);
        subTotalInclude += parseFloat(codPrice);
      } else {
        subTotalExclude += parseFloat(order.cod_price_final);
      }

      if (!vatOnProduct && !vatOnShipping && !vatOnCod) {
        totalBeforeVat = newOrder.total;
      }
      
      totalBeforeVat = totalBeforeVat - totalVat;
      newOrder.total_before_vat = totalBeforeVat.toFixed(2);
      newOrder.total_vat = totalVat.toFixed(2);
      newOrder.vat_method = parseFloat(newOrder.total_vat) > 0 ? 2 : 1;

      newOrder.sub_total_include = subTotalInclude;
      newOrder.sub_total_include_vat = (parseFloat(subTotalInclude) * 7 / 107);
      newOrder.sub_total_include_before_vat = parseFloat(subTotalInclude) - parseFloat(newOrder.sub_total_include_vat);

      newOrder.sub_total_exclude = subTotalExclude;
      newOrder.sub_total_exclude_vat = (parseFloat(subTotalExclude) * 7 / 107);
      newOrder.sub_total_exclude_before_vat = parseFloat(subTotalExclude) - parseFloat(newOrder.sub_total_exclude_vat);

      newOrder.discount_vat = (parseFloat(order.discount_final) * 7 / 107);
      newOrder.discount_before_vat = parseFloat(order.discount_final) - parseFloat(newOrder.discount_vat);

      newOrder.discount_include = discountInclude;
      newOrder.discount_include_vat = (parseFloat(discountInclude) * 7 / 107);
      newOrder.discount_include_before_vat = parseFloat(discountInclude) - parseFloat(newOrder.discount_include_vat);

      newOrder.discount_exclude = discountExclude;
      newOrder.discount_exclude_vat = (parseFloat(discountExclude) * 7 / 107);
      newOrder.discount_exclude_before_vat = parseFloat(discountExclude) - parseFloat(newOrder.discount_exclude_vat);

      newOrder.total_include = parseFloat(subTotalInclude) - parseFloat(discountInclude);
      newOrder.total_include_vat = (parseFloat(newOrder.total_include) * 7 / 107);
      newOrder.total_include_before_vat = parseFloat(newOrder.total_include) - parseFloat(newOrder.total_include_vat);
      newOrder.total_exclude = parseFloat(subTotalExclude) - parseFloat(discountExclude);
      newOrder.total_exclude_vat = (parseFloat(newOrder.total_exclude) * 7 / 107);
      newOrder.total_exclude_before_vat = parseFloat(newOrder.total_exclude) - parseFloat(newOrder.total_exclude_vat);

      return newOrder;
    },
    badgeClass() {
        return [
            'badge-secondary',
            'badge-primary',
            'badge-success',
            'badge-info',
            'badge-warning',
            'badge-danger',
        ];
    },
    addPaymentStatus: async function (orders) {
        var tmpOrder = [];
        if(orders.id) {
            tmpOrder.push(orders);
        }else{
            tmpOrder = orders
        }

        for await (let order of tmpOrder) {
            var paymentStatus = 'waiting';
            let confirmedSumPaid = 0;
            var allSumWaiting = 0;

            if(!order.sales_order_payment.length) {
              order.payment_status = paymentStatus;
              continue
            }

            if(order.total == 0) {
              const payment = order.sales_order_payment.filter(item => item.state != 'canceled').some(item => item.state == 'confirmed')
              order.payment_status = payment ? 'confirmed' : 'paid'
              continue
            }

            for await (let orderPayment of order.sales_order_payment) {
              if(orderPayment.state == 'confirmed'){
                confirmedSumPaid += parseFloat(orderPayment.paid);
              }
              if(orderPayment.state == 'waiting'){
                allSumWaiting += parseFloat(orderPayment.paid);
              }
            }
            let sum = confirmedSumPaid +  allSumWaiting;

            if((sum > 0) && (sum < parseFloat(order.total))){
              //  confirmedSumPaid +  allSumWaiting <  total = partial_paid
              paymentStatus = 'partial_paid';
            }
            else if(confirmedSumPaid >= parseFloat(order.total)){
              // confirmedSumPaid >  total  = confirmed
              paymentStatus = 'confirmed';
            }
            else if(sum >= parseFloat(order.total)){
              //  confirmedSumPaid +  allSumWaiting >  total = paid
              paymentStatus = 'paid';
            }

            order.payment_status = paymentStatus;
        }

        if(orders.id) {
            orders = tmpOrder[0];
        }else{
            orders = tmpOrder;
        }
    },
    bankLogo: function (saleOrderPayment) {
        let image = this.getImageSrc('bank/none');
        if (saleOrderPayment.length > 0) {
            const [firstSalesOrderPayment] = saleOrderPayment;
            if (firstSalesOrderPayment.bank_account) {
                if (firstSalesOrderPayment.bank_account.bank.logo !== null) {
                    image = firstSalesOrderPayment.bank_account.bank.logo;
                }
            }
        }
        return image;
    },
    paymentLogo: function (icon) {
      let image = this.getImageSrc("payment/Other"); //if no icon payment in nevergiveup, use other payment icon
      if (icon) {
        image = icon;
      }
      return image;
    },
    alertSlipDetect(self) {
      self.$swal.fire({
        title: i18n.t('_Slip.Slip not found')+' !',
        icon: 'warning',
        iconColor: '#FF7043',
        html: i18n.t('_Slip.Please check your payment slip before saving the order'),
        confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-2"></i>' + i18n.t('OK'),
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light'
        },
        focusConfirm: false
      });
    },
    openWebSocket() {
      console.log("remove ")
    },
    async confirmOrderSuccess (self) {
      self.$swal.fire({
        title: i18n.t('Order Confirmation Success'),
        icon: 'success',
        html: i18n.t('The order has been confirmed'),
        confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-2"></i>' + i18n.t('OK'),
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary',
        },
        focusConfirm: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
          if (result.isConfirmed) {
            store.dispatch("order/isModalOrderConfirm", false);
            self.$toastr.s(i18n.t("Confirm Order Success"), "<i class='fa-solid fa-circle-check mr-2'></i>" + i18n.t('Success'));
            self.afterConfirmCancelOrder();
            self.$swal.close();
          }
      });
    },
    async confirmOrderCod (orderData, self) {
      let payload = {};
      let orderIds = [];
      await orderData.map(function(orderItem) {
        let shipmentUsed = 0;
        if (orderItem.shipments.length > 0) {
          orderItem.shipments.map(function(shipmentItem) {
            if (shipmentItem.canceled_date == "") {
              shipmentUsed = shipmentUsed + 1;
            }
          });
        }
        if (
          orderItem.payment_method == "COD" &&
          orderItem.cod_confirm_date == "" &&
          shipmentUsed == 0 &&
          orderItem.sales_channel_group != 'Marketplace'
        ) {
          orderIds.push(orderItem.id);
        }
      });
      payload["order_ids"] = orderIds;

      let htmlSwal = '<div class="card border-0 mb-0 mt-2 px-2">';
          htmlSwal+= '  <div class="row g-0">';
          htmlSwal+= '    <div class="col-2 bg-blue rounded-left justify-content-center align-items-center" style="display: flex;">';
          htmlSwal+= '      <i class="fa-solid fa-circle-info font-size-big"></i>';
          htmlSwal+= '    </div>';
          htmlSwal+= '    <div class="col border-1 border-blue rounded-right" style="background-color: #DBEEFD; color: #114E7E;">';
          htmlSwal+= '      <div class="card-body p-2">';
          htmlSwal+= '        <p class="card-text text-left mb-1">';
        if (localRead('local') == 'th') {
          htmlSwal+= '          สามารถยืนยันคำสั่งได้ ' + orderIds.length + ' จาก ' + orderData.length + ' รายการ ';
        } else if (localRead('local') == 'en') {
          htmlSwal+= '          ' + ' You can confirm ' + orderIds.length + ' out of ' + orderData.length +' orders. ';
        }
          htmlSwal+= '          ' + i18n.t('for the following reasons') + ':';
          htmlSwal+= '        <p class="card-text text-left ml-2">';
          htmlSwal+= '              1. ' + i18n.t('Must be a manual order channel.');
          htmlSwal+= '          <br>2. ' + i18n.t('Must be a Cash on Delivery (COD) payment.');
          htmlSwal+= '          <br>3. ' + i18n.t('The order has not been confirmed.');
        // if (settingUpsell.data.data.enable == 1) {
        //   htmlSwal+= '          <br>3. ' + i18n.t('Some order still in upsell process');
        // }
          htmlSwal+= '        </p>';
          htmlSwal+= '        </p>';
          htmlSwal+= '      </div>';
          htmlSwal+= '    </div>';
          htmlSwal+= '  </div>';
          htmlSwal+= '</div>';

      await store.dispatch("order/isModalOrderConfirm", false);
      await self.$nextTick(function () {
        store.dispatch("order/isModalOrderConfirm", true);
      });
      let storeIndex = this;
      await self.$nextTick(async function () {
        const moc = await self.$parent.$refs.footerContent.$refs.modalOrderConfirm;
        await self.$swal
        .fire({
          title: i18n.t("Confirm Order") + " ?",
          icon: "warning",
          iconColor: "#FF7043",
          html: htmlSwal,
          showConfirmButton: orderIds.length > 0 ? true : false,
          showCancelButton: true,
          confirmButtonText: '<i class="fa-solid fa-floppy-disk mr-1"></i>' + i18n.t("Confirm"),
          cancelButtonText: orderIds.length > 0 ? i18n.t('Cancel') : '<i class="fa-solid fa-thumbs-up mr-2"></i>' + i18n.t('OK'),
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-primary mr-2',
            cancelButton: orderIds.length > 0 ? 'btn btn-light' : 'btn btn-primary',
            loader: 'custom-loader',
          },
          loaderHtml: '<div class="spinner-border text-primary"></div>',
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            moc.totalOrder = orderIds.length;
            moc.showModal = true;
            // use goQueue =================================
            let userId = JSON.parse(Cookies.get('user')).id;
            let tenantId = JSON.parse(Cookies.get('tenant')).id
            const confirmCodSocketName = `confirm.order.cod${userId}${tenantId}`
 
            if(localStorage.getItem('isCypress')){
              moc.actionList = [];
              if(localStorage.getItem('cypressDataWebsocket')){
                let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket')); 
                dataWebsocket.forEach(data => {
                  let codConfirmItem = JSON.parse(JSON.stringify(data)) 
                  storeIndex.socketCallback(codConfirmItem.data, moc, false, self, orderIds); 
                });
              }
            }else{
              storeIndex.openNewWebsocket(confirmCodSocketName, orderIds, 1, moc, self)
            // use goQueue =================================
            }
            
            confirmCod(payload).then(response => {
              const key = Object.keys(response); 
              if (!key.includes('data')) {
                if(response.statusCode == 500 || response.statusCode == 502 || response.statusCode == 504 || response.statusCode == 400) {
                  self.$toastr.e(self.$t('Confirm Order Failed'), "<i class='t-icon icon-blocked mr-2'></i>" + self.$t('Failed'));
                }else if(response.statusCode == 403){
                  self.popupAccessDenied(); 
                }
                store.dispatch("order/isModalOrderConfirm", false);
              }
            });
          }
        });
      });
    },
    alertNotFeature(self) {
      self.$swal.fire({
        imageUrl: require('@/assets/global_assets/images/access_not_available.png'),
        title: self.$t('Access Not Available') + '!',
        html: self.$t("Current plan is not support this feature.")+"<br/>"+self.$t("Please subscribe upper plan to access the feature."),
        confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + self.$t('Upgrade Now')+'!',
        cancelButtonText: '<i class="fa-solid fa-circle-check mr-1"></i>' + self.$t('Got It'),
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary",
          title: "pt-0"
        },
        reverseButtons: true,
        preConfirm: async function () {
          self.$router.push({ path: '/app/premium-subscriptions'});
        },
      });
    },
    popupAccessDenied(self) {
      self.$swal({
        imageUrl: require('@/assets/images/activities/icon-access-denied.png'),
        title: self.$t('Access Denied')+' !',
        html: self.$t('You do not have permission to access this page.')+'<br/>' + self.$t('If you feel this is a mistake, contact your admin.'),
        confirmButtonText: '<i class="fa-solid fa-circle-check mr-1"></i>' + self.$t('Got It'),
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        focusConfirm: false
      });
    },
    errorToast(self, message){
      self.$toastr.Add({
        type: "warning",
        title: "<span class='icon-warning22'></span>" + self.$t("Error"),
        msg: self.$t(message),
        clickClose: true,
        timeout: 5000,
        position: "toast-top-right",
      });
    },
    toastAlert(type = "", title = null, description = null, self) {
      let icon = "";
      switch (type) {
        case "error":
          icon = "<i class='fa-solid fa-ban mr-2'></i>";
          break;
        default:
          icon = "<i class='fa-sharp fa-solid fa-circle-check mr-2'></i>";
          break;
      }
      self.$toastr.Add({
        type: type,
        title: icon + self.$t(title),
        msg: self.$t(description),
        clickClose: true,
        timeout: 5000,
        position: "toast-top-right",
      });
    },
    async openNewWebsocket(clientUid, ids, count, moc, self, loading = false) {
      const vm = this;
      const ws = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      console.log(vm, 'vm');
      if (moc.actionList) {
        moc.actionList = [];
      }
      console.log({clientUid})
      ws.onopen = function open() {
        //open socket
        ws.send(JSON.stringify({
          data: {clientUid},
          event: "subscribe"
        }));

        if (moc.intervalData) {
          moc.intervalData = setInterval(() => {
            ws.send(JSON.stringify({
              "data": {clientUid},
              "event": "pusher:ping"
            }));
          }, 10000);
        }
      };

      ws.onmessage = async function incoming(message) {
        const data = JSON.parse(message.data)
        data.data.message = data.data.message == null ? 'done' : data.data.message
        if (data.data.clientUid == clientUid) {
          const wsRes = data.data;
          const keys = Object.keys(wsRes);
          switch (data.event) {
            case 'confirm.order.cod':
              if (!moc.actionList) {
                return;
              }
    
              if (typeof vm.socketCallback === 'function') {
                console.log("socketCallback is a function");
              } else {
                console.error("socketCallback is not a function");
              }
    
              if (keys.includes('status')) {
                vm.socketCallback(wsRes, moc, ws, self, ids);
              } else if (keys.includes('forceCreate') && wsRes.forceCreate) {
                const successRow = moc.actionList.filter(obj => obj.status == true)
                const successIds = successRow.length ? successRow.map(obj => obj.id) : [];
                let createId = wsRes.ids.filter(id => !successIds.includes(id))
                while (createId.length) {
                  const id = createId.shift()
                  const createShipment = await Api.Order.postCreateShipment(id);
                  if (createShipment.data.status || createShipment.data.message == 'can not create shipment') {
                    vm.socketCallback({
                      orderId: id,
                      status: true,
                      message: 'done'
                    }, moc, ws, self, ids);
                  } else {
                    vm.socketCallback({
                      orderId: id,
                      status: false,
                      message: 'server error'
                    }, moc, ws, self, ids);
                  }
                }
              }
              break;
            case 'order.cancel':
              if (typeof vm.cancelSocketCallback === 'function') {
                console.log("cancelSocketCallback is a function");
              } else {
                console.error("cancelSocketCallback is not a function");
              }

              vm.cancelSocketCallback(self, ids, [parseFloat(wsRes.orderId)], [], loading, wsRes.index, clientUid, keys.includes('status'), ws)
              break;
          }
        }
      };
    },
    async socketCallback(e, moc, socketInstant = false, self, ids = []) {
      if (!ids.includes(e.orderId)) return;
      if (!moc.actionList.find(obj => obj.id == e.orderId)) {
        moc.countConfirmOrder += 1;
      }
      if(e.status) {
        if(e.message == 'done') {
          if (!moc.actionList.find(obj => (obj.id == e.orderId && obj.status == true))) {
            moc.actionList.push({
              id: e.orderId,
              status: true
            });

            moc.listMsg.unshift({
              'status': e.status,
              'message': self.$t(e.message),
              'orderNumber' : e.orderId,
            });
          }
        }
      } else {
        moc.showLogError = true;
        if (!moc.actionList.find(obj => (obj.id == e.orderId && obj.status == false))) {
          moc.actionList.push({
            id: e.orderId,
            status: false
          });

          moc.listMsg.unshift({
            'status': e.status,
            'message': self.$t(e.message),
            'orderNumber' : e.orderId,
          });
        }
      }
      if (moc.countConfirmOrder == moc.totalOrder) {
        if (moc.intervalData) {
          clearInterval(moc.intervalData);
        }
        if (socketInstant) {
          socketInstant.close();
        }
        moc.closeModal = true;
        if (!moc.showLogError) {
          setTimeout(() => {
            this.confirmOrderSuccess(self);
          }, 1000);
        } else if (moc.showLogError) {
          let orderFails = await moc.actionList.filter(obj => !obj.status);
          const failsCount = orderFails.length;
          const successCount = moc.totalOrder - failsCount;
          self.$swal.fire({
            title: self.$t('Error'),
            icon: 'warning',
            iconColor: '#FF7043',
            html: self.$t('Unable to confirm') + ` ${failsCount} ` + self.$t('orders') + ', ' + self.$t('success') + ` ${successCount} ` + self.$t('orders'),
            confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-2"></i>' + self.$t('OK'),
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-light'
            },
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then((result) => {
              if (result.isConfirmed) {
                self.afterConfirmCancelOrder();
                if (moc.totalOrder == failsCount) {
                  self.$toastr.e(i18n.t("Confirm Order Failed"), "<i class='t-icon icon-blocked mr-2'></i>" + i18n.t('Failed'));
                } else {
                  self.$toastr.s(i18n.t("Confirm Order Success"), "<i class='fa-solid fa-circle-check mr-2'></i>" + i18n.t('Success'));
                }
                self.$swal.close();
              }
          });
        }
      }
    },
    async cancelOrder(orderData, self, loading, channelEvent, reason = undefined, itemsList = undefined, reasonCancel = false) {
      let orderArray = [];
      let result = [];
      let orderIdRouter = '';
      let payload = { "uuid": channelEvent };
      let running = 0;
      let orderIds = '';
      let integrationType = null;
      let storeIndex = this;


      Object.keys(orderData).forEach(key => {
        if(orderData[key] != null){
          if(this.isset(() => orderData[key].sales_channel_code)){
            console.log('orderData[key].sales_channel_code',orderData[key].sales_channel_code);
            if(orderData[key].sales_channel_code == 'LINE_SHOP'){
              result.push(orderData[key].sales_channel_code);
            }
          }

          if(orderData[key].shipments != undefined){
            if(orderData[key].shipments.length > 0){
              if(orderData[key].sales_channel_code != 'LINE_SHOP' && orderData[key].sales_channel_group == "Marketplace"){
                if(orderData[key].shipments[0].status != 'to_ship' && orderData[key].shipments[0].status != 'packing' && orderData[key].shipments[0].status != 'ready_to_ship' && orderData[key].shipments[0].status != 'canceled'){
                  result.push(orderData[key].shipments[0]);
                }
              }else{
                if(orderData[key].shipments[0].status != 'to_ship' && orderData[key].shipments[0].status != 'canceled'){
                  result.push(orderData[key].shipments[0]);
                }
              }
            }
          }
        }
      });
      if(result.length > 0){
          self.$swal.fire({
            title: self.$t('_Order.Order cannot be canceled'),
            icon: 'error',
            html: self.$t('_Order.Some orders cannot be cancelled'),
            confirmButtonText: self.$t('OK'),
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-light'
            },
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          });
        return;
      }

      if (!Array.isArray(orderData)) {
        if (orderData.sales_channel_type === 'Salepage') {
          let hasFeature = await Api.Feature.postHasFeature('feature-salepage');
          if (!hasFeature.data.status) {
            self.$refreshSubscriptionExpiredModal++;
            return;
          }
        }

        orderArray.push(orderData);
        orderIdRouter = orderData.id
        orderIds = [orderIdRouter];
      } else if (Array.isArray(orderData)) {
        orderArray = orderData;
        orderIdRouter = orderArray[0].id;
        payload["multiOrderId"] = orderArray.map(id => id.id);
        orderIds = payload.multiOrderId;
      }

      // set standard swal ====================================================
      let showRejectButton = false;
      let cancelByBuyer = false;
      let titleSwal = i18n.t("Cancel Orders") + " ?";
      let htmlSwal = i18n.t("You will not be able to undo this action.");
      let textConfirmButton = '<i class="fas fa-check-circle mr-1"></i>' + i18n.t("Confirm");
      let customClassConfirmButton = '';
      // check market place ===================================================
      var listMarketplace = ['TIKTOK_SHOP','SHOPEE_SHOP','LAZADA_SHOP'];
      if (orderArray.length == 1) {
        if (orderArray[0].sales_channel_group == 'Marketplace' || orderArray[0].integration_sales_channel != undefined && orderArray[0].integration_sales_channel.integration_type.integration_group_id == 3) {
          integrationType = orderArray[0];

          if ((orderArray[0].order_external_status != undefined && orderArray[0].order_external_status == 'IN_CANCEL') || (integrationType.sales_order_status != undefined && integrationType.sales_order_status[0].name == 'IN_CANCEL')){
            let resOrderMarketPlace = await Api.Order.getOrderMarketplaceDetail(orderIdRouter);
            // if(resOrderMarketPlace.data.data.reverse_order_id == ""){
            //   self.afterConfirmCancelOrder();
            // }else{
              let buyerReason = resOrderMarketPlace.data.data.buyer_cancel_reason;
              showRejectButton = true;
              cancelByBuyer = true;
              titleSwal = i18n.t("Confirm Cancel Orders") + " ?";
              htmlSwal = i18n.t(buyerReason);
              textConfirmButton = '<i class="fas fa-check-circle mr-1"></i>' + i18n.t("Approve");
              customClassConfirmButton = ' confirm-cancel-order';
            // }
          } else if (!reasonCancel) {
            self.cancelOrderMarketplace(orderArray[0]);
            return;
          }
        }
      } else if (orderArray.length > 1) {
        for (const [key, item] of Object.entries(orderArray)) {
            if (
              item.sales_channel_group == 'Marketplace' ||
              item.order_external_status != '' &&
              item.order_external_status == 'IN_CANCEL' &&
              listMarketplace.includes(item.sales_channel_code)
            ){
              // cancel market place, multiple items cannot be selected.
              self.$swal.fire({
                title: self.$t('_Order.Order cannot be canceled'),
                icon: 'error',
                html: self.$t('_Order.Please select each sales channel'),
                confirmButtonText: self.$t('OK'),
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light'
                },
                focusConfirm: false,
                allowOutsideClick: false,
                allowEscapeKey: false
              });
              return;
            }
        }
      }

      self.$swal
        .fire({
          title: titleSwal,
          icon: "warning",
          iconColor: "#FF7043",
          html: htmlSwal,
          showDenyButton: showRejectButton,
          denyButtonText: '<i class="fa-solid fa-circle-xmark mr-1"></i>' + i18n.t("Reject"),
          showCancelButton: true,
          confirmButtonText: textConfirmButton,
          cancelButtonText: i18n.t("Cancel"),
          buttonsStyling: false,
          customClass: {
            denyButton: "btn btn-danger ml-0",
            confirmButton: "btn btn-primary mr-2 " + customClassConfirmButton,
            cancelButton: "btn btn-light",
            loader: "custom-loader",
          },
          loaderHtml: '<div class="spinner-border text-primary"></div>',
          focusConfirm: false,
          showLoaderOnConfirm: true,
          showLoaderOnDeny: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          preConfirm: async function () {
            try {
              if(!localStorage.getItem('isCypress')){
                // storeIndex.openWebSocket();
                let userId = JSON.parse(Cookies.get('user')).id;
                let tenantId = JSON.parse(Cookies.get('tenant')).id
                const clientUid = `order.cancel${userId}${tenantId}`
                storeIndex.openNewWebsocket(clientUid, orderIds, 1, self, self, loading)
              }
              // enable loading ==========================================================
              if (loading) {
                store.dispatch("order/setInProgressOrder", {orderIds: orderIds, status: true});
              }

              if(orderArray[0].sales_channel_group != undefined && orderArray[0].sales_channel_group == 'Marketplace' || orderArray[0].integration_sales_channel != undefined && orderArray[0].integration_sales_channel.integration_type.integration_group_id == 3){
                let partnerResponse = null;
                let body = null;
                if (cancelByBuyer) {
                  body = {
                    "operation": "ACCEPT"
                  }
                  partnerResponse = await Api.Order.confirmCancelByBuyer(orderArray[0].id, body);
                }else{
                  let integrationCode = orderArray[0].integration_sales_channel.integration_type.code;
                  switch (integrationCode) {
                      case 'TIKTOK_SHOP':
                        body = {
                        "reason_key": reason
                      }
                      break;
                      case 'SHOPEE_SHOP':
                        if(reason == "OUT_OF_STOCK"){
                          body = {
                            "reason_key": reason,
                            "item_list": itemsList,
                          }
                        }else{
                          body = {
                            "reason_key": reason,
                          }
                        }
                      break;
                      case 'LAZADA_SHOP':
                        body = {
                        "reason_key": reason
                      }
                      break;
                    default:
                      break;
                  }
                  partnerResponse = await Api.Order.confirmCancel(orderArray[0].id, body);
                }

                if(partnerResponse.data.code != 0){
                  self.$toastr.e(self.$t('_Order.Cancel Orders Failed'), "<i class='t-icon icon-blocked mr-2'></i>" + self.$t("Failed"));
                  self.$swal.getConfirmButton().innerHTML = '<i class="fas fa-redo mr-2"></i>' + self.$t('Try again');
                  return false;
                }
              }

              cancel(orderIdRouter, payload)
              .then(response => {
                if(Object.keys(response).includes("code") && response.code == "ERROR_VALIDATION") {
                    self.$swal.fire({
                      title: self.$t('_Order.Unable to Cancel Order'),
                      icon: 'error',
                      html: self.$t('_Order.This order has active tracking no'),
                      confirmButtonText: self.$t('OK'),
                      buttonsStyling: false,
                      customClass: {
                          confirmButton: 'btn btn-primary',
                          cancelButton: 'btn btn-light'
                      },
                      focusConfirm: false,
                      allowOutsideClick: false,
                      allowEscapeKey: false
                    });
                  return;
                }
                let channelEcho ='';
                if (localStorage.getItem('isCypress')) {
                  if (localStorage.getItem('cypressDataWebsocket')) {
                    let dataWebsocket = []; 
                    dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket')); 
                    dataWebsocket.forEach(async data => { 
                      let dataOrderId=[];
                      orderIds=[];
                      dataOrderId.push(data.data.orderId);
                      orderIds.push(data.data.orderId); 
                      running++
                      storeIndex.cancelSocketCallback(self,orderIds,data.data.orderId,dataOrderId,loading,running,channelEcho)
                    }); 
                  }                 
                } else {
                  // channelEcho ='order_cancel'+channelEvent;
                  // window.Echo.channel(channelEcho).listen('.order.cancel', async (e)=> {
                  //   console.log(loading+'/'+running, 'loading');
                  //   running++
                  //   e.orderId = parseFloat(e.orderId)
                  //   storeIndex.cancelSocketCallback(self,orderIds,[e.orderId],[],loading,running,channelEcho)
                  // });
                }

              }).catch(error => {
                if (loading) {
                  store.dispatch("order/setInProgressOrder", {orderIds: orderIds, status: false});
                }
                if(error.response.status == 500 || error.response.status == 502 || error.response.status == 504 || error.response.status == 400){
                  self.$toastr.e(self.$t('_Order.Cancel Orders Failed'), "<i class='t-icon icon-blocked mr-2'></i>" + self.$t("Failed"));
                }else if (error.response.status == 403) {
                  self.popupAccessDenied(s);
                }
              });

            } catch (e) {
              console.log(e);
              if (e.response.status === 403) {
                self.$swal.getTitle().textContent = self.$t('Access Denied');
                self.$swal.getHtmlContainer().textContent = self.$t('You do not have permission to access this page.');
                self.$swal.getConfirmButton().innerHTML = '<i class="fas fa-redo mr-2"></i>' + self.$t('Try again'),
                  self.$swal.showValidationMessage(
                    self.$t(e.response.data.message)
                  );
              }
            }
          },
          preDeny: async function () {
            if(cancelByBuyer){
              try {
                console.log('Is Reject!!!');
                let body = {};
                body = {
                  "operation": "REJECT"
                }
                let partnerResponse = await Api.Order.confirmCancelByBuyer(orderIdRouter, body);
                if(partnerResponse.data.code != 0){
                  self.$toastr.e(self.$t('Reject Cancle Orders Failed'), "<i class='t-icon icon-blocked mr-2'></i>" + self.$t("Failed"));
                  self.$swal.getConfirmButton().innerHTML = '<i class="fas fa-redo mr-2"></i>' + self.$t('Try again');
                  return false;
                }

                self.$toastr.s(self.$t('Reject Cancle Orders Complete'), "<i class='fa-solid fa-circle-check mr-2'></i>" + self.$t('Success'));
                self.$swal.close();
                self.afterConfirmCancelOrder();

              } catch (e) {

              }
            }
          }
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (!loading) {
              self.$swal.fire({
                title: titleSwal,
                icon: "warning",
                iconColor: "#FF7043",
                html: htmlSwal,
                allowEscapeKey: false,
                allowOutsideClick: false,
              });
              self.$swal.showLoading();
            }
            self.isModalReasonCancel = false;
            $("#reason_cancel_order").modal("hide");
          } else if (result.isDenied) {
            self.$swal.close();
            self.afterConfirmCancelOrder();
          } else {
            // disable loading ==================================================
            if (loading) {
              store.dispatch("order/setInProgressOrder", {orderIds: orderIds, status: false});
            }
          }
        });
    },
    async cancelSocketCallback(self,orderIds,orderId,dataOrderId,loading,running,channelEcho, result = true, socketInstant = false) {
      if (dataOrderId.length > 0) {
        dataOrderId = dataOrderId
      } else {
        dataOrderId = orderId
      }

      if (result) {
        // checkmark success
        if (loading) {
          store.dispatch("order/setInProgressOrder", {orderIds: dataOrderId, status: 'checkmark'});
        }
        let resShipment = await Api.Order.checkShipment(orderId);
        if (resShipment.data.shipment_id != null) {
          let shipmentId = resShipment.data.shipment_id;
          await Api.Shipment.putCancelShipment({ id: shipmentId });
        }
      } else {
        // checkmark fail
        if (loading) {
          store.dispatch("order/setInProgressOrder", {orderIds: dataOrderId, status: false});
        }
      }

      // last order
      if (orderIds.length == running) {
        if (!localStorage.getItem('isCypress')) {
          if (self.intervalData) {
            clearInterval(self.intervalData);
          }
          if (socketInstant) {
            socketInstant.close();
          }
          // window.Echo.leave(channelEcho);
        }
        self.$swal.fire({
          title: self.$t('_Order.Cancel Orders Success'),
          icon: 'success',
          html: self.$t('_Order.You will not be able to undo this action'),
          confirmButtonText: self.$t('OK'),
          buttonsStyling: false,
          customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-light'
          },
          focusConfirm: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then((result) => {
          if (result.isConfirmed) {
            self.$toastr.s(self.$t('_Order.Cancel Orders Complete'), "<i class='fa-solid fa-circle-check mr-2'></i>" + self.$t('Success'));
            self.$swal.close();
            self.afterConfirmCancelOrder();
          }
        });
      }
    },
    showCancelled(order){
      let html = '-';
      if (this.isset(() => order.order_external_status)) {
        switch (order.order_external_status) {
          case 'IN_CANCEL':
            if(
                order.payments.length > 0 &&
                order.canceled_date == ""
              ){
              let current = new Date();
              let currentTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
              let orderPaidDate = order.payments[0].paid_date;
              let warningTime = moment(orderPaidDate, "YYYY-MM-DD HH:mm:ss").add(7, 'days').format('YYYY-MM-DD HH:mm:ss')

              var hours = moment
                .duration(moment(currentTime, 'YYYY-MM-DD HH:mm:ss')
                .diff(moment(warningTime, 'YYYY-MM-DD HH:mm:ss'))
                ).asHours();

              console.log(currentTime,'currentTime');
              console.log(warningTime,'warningTime');
              console.log(hours,'hours');

              html = '<span class=" badge badge-danger"><i class="fa-solid fa-message-exclamation mr-1"></i>'+ i18n.t('_MKP.Request')+'</span>';
              if(hours > 0 && hours <= 24){
                html = '<span class=" badge badge-danger"><i class="fa-solid fa-hourglass-clock mr-1"></i>'+ '1 ' + i18n.t('day')+'</span>';
              }

              return html;

            }
            break;
          case 'UNPAID':
          case 'AWAITING_SHIPMENT':
          case 'AWAITING_COLLECTION':
          case 'READY_TO_SHIP':
          case 'PROCESSED':
            let current = new Date();
            let currentTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
            let createdDate = order.created_date;
            let warningTime = moment(createdDate, "YYYY-MM-DD HH:mm:ss").add(7, 'days').format('YYYY-MM-DD HH:mm:ss');

            var hours = moment
            .duration(moment(currentTime, 'YYYY-MM-DD HH:mm:ss')
            .diff(moment(warningTime, 'YYYY-MM-DD HH:mm:ss'))
            ).asHours();
            if(hours > 0 && hours <= 24){
              html = '<span class=" badge badge-danger"><i class="fa-solid fa-hourglass-clock mr-1"></i>'+ '1 ' + i18n.t('day')+'</span>';
            }
          break;
        }
      }
      return html;
    },
    showCancelledDetail(order){
      let html = '-';
      if ((this.isset(() => order.sales_order_status[0].name))) {
        switch (order.sales_order_status[0].name) {
          case 'IN_CANCEL':
            if(
                order.sales_order_payment.length > 0 &&
                !order.canceled_date
              ){
              let current = new Date();
              let currentTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
              let orderPaidDate = order.sales_order_payment[0].paid_date;
              let warningTime = moment(orderPaidDate, "YYYY-MM-DD HH:mm:ss").add(7, 'days').format('YYYY-MM-DD HH:mm:ss')

              var hours = moment
                .duration(moment(currentTime, 'YYYY-MM-DD HH:mm:ss')
                .diff(moment(warningTime, 'YYYY-MM-DD HH:mm:ss'))
                ).asHours();
              html = '<span class=" badge badge-danger"><i class="fa-solid fa-message-exclamation mr-1"></i>'+ i18n.t('_MKP.Request')+'</span>';
              if(hours > 0 && hours <= 24){
                html = '<span class=" badge badge-danger"><i class="fa-solid fa-hourglass-clock mr-1"></i>'+ '1 ' + i18n.t('day')+'</span>';
              }

              return html;

            }
            break;
            case 'UNPAID':
            case 'AWAITING_SHIPMENT':
            case 'AWAITING_COLLECTION':
            case 'READY_TO_SHIP':
            case 'PROCESSED':
              let current = new Date();
              let currentTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
              let createdDate = order.created_date;
              let warningTime = moment(createdDate, "YYYY-MM-DD HH:mm:ss").add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
              var hours = moment
              .duration(moment(currentTime, 'YYYY-MM-DD HH:mm:ss')
              .diff(moment(warningTime, 'YYYY-MM-DD HH:mm:ss'))
              ).asHours();
              if(hours > 0 && hours <= 24){
                html = '<span class=" badge badge-danger"><i class="fa-solid fa-hourglass-clock mr-1"></i>'+ '1 ' + i18n.t('day')+'</span>';
              }
            break;
        }
      }
      return html;
    },
    sendNameToNative(name) {
      try {
        console.log('Can messageHandlers reach native code ' + name);
        webkit.messageHandlers.callback.postMessage(name);
      } catch(err) {
        console.log('Can not reach native code ' + name);
      }
    },
    b64EncodeUnicode(str) {
      return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1);
      }));
    },
    b64DecodeUnicode(str) {
      return decodeURIComponent(window.atob(str).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    }
    ,
    isCod(payment) {
      let text = null;
      let paymentName = null;

      if(typeof payment == 'string'){
        paymentName = payment;
      }else{
        paymentName = payment.name;
      }

      text = paymentName.toLowerCase().trim().replace(/ +/g, "");
      text = text.replace(/[^a-zA-Z ]/g, "")

      let checkTextIsCod = text.includes("cod");
      let checkTextIsOnDelivery = text.includes("ondelivery");

      if(checkTextIsCod || checkTextIsOnDelivery){
        return true
      }
      return false
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    removeLastCharacter(string, txt) {
      return string.split(txt).filter(value => value.length).join().replaceAll(',', txt);
    },
    async carrierOptionHasFeature(carrier) {
      let carrierCode = carrier.integration.integration_type.code || '';
      
      if(carrierCode == "SELLER_OWN_FLEET"){
        carrier.disabled = !store.state.user.feature.includes('feature-seller-own-fleet')
      }
    },
    async delay(ms) {
      return await new Promise( resolve => setTimeout(resolve, ms));
    },
    notRunningNo(obj) {
      // ตรวจสอบว่ามีคีย์ "running_no" และค่าของมันไม่ใช่ null หรือ undefined
      return obj.hasOwnProperty("running_no") && (!/^\d+$/.test(obj.running_no)) && obj.order_number.length >= 36;
    },
    runningElementId(obj) {
      const elementName = 'order-number';
      let id = 0;
      if (obj.hasOwnProperty("sales_order_id")) {
        id = obj.sales_order_id
      } else if (obj.hasOwnProperty("order_id")) {
        id = obj.order_id
      } else {
        id = obj.id
      }
      return `${elementName}-${id}`
    },
    getDataTestName(item) {
      let name = null;
      // console.log('item',item)
      if (typeof item === 'string') {
        name = item;
      } else {
        if (item.hasOwnProperty("title")) {
          name = item.title;
        }
        if (item.hasOwnProperty("text")) {
          name = item.text;
        }
        if (item.hasOwnProperty("name") && item.hasOwnProperty("description")) {
          name = item.title + "-" + item.description;
        }
        if (item.hasOwnProperty("name")) {
          name = item.name;
        }
        if (!name) {
          return
        }
      }
      let lowerCase = name.toLowerCase();
      let transFormed = lowerCase.replace(/{|}/g, "-")    // แทนที่ { และ } ด้วย -
      .replace(/[\s&()|$+?]+/g, "-")      // แทนที่ช่องว่างและสัญลักษณ์อื่นๆ ด้วย -
      .replace(/-+$/, "");
      
      return transFormed;
    },
    convertTextMaximumMinimum(type,number){
      let text = '';
      if(type == 'Minimum'){
        text = i18n.t(`Minimum Character Limit {minimum}.`);
        text = text.replace('{minimum}', number);
        return text;
      }
      text = i18n.t(`Maximum Character Limit {maximum}.`);
      text = text.replace('{maximum}', number);
      return text;
    },
    async resendConfirmEmail(ids, self, viewAction = false, actionPage = 'entry') {
      const Swal = self.$swal;
      try {
        const tryAgainText = self.$t("Try again");
        const accessDeniedHtml = self.$t("Access Denied");
        let title = self.$t("Resend Email")+' ?';
        let html = self.$t("The system will resend the registration confirmation to email.");
        let confirmButtonText = '<i class="fas fa-check-circle mr-1"></i> ' + self.$t("Confirm");

        let formId = self.$route.params.id;
        let data = {
            submit_ids : ids
          }
        Swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: self.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            confirmButtonText = '<i class="fa-solid fa-rotate-right"></i> ' + tryAgainText;
            try {
              const response = await Api.ToolV2.putResendEmailConfirm(formId, data);
              if(response.status != 200 && response.status != 201){
                throw response
              }
              self.$storeIndex.toastAlert('success', 'Success', 'Resend Email Confirm Success.', self);
            } catch (error) {
              switch (Number(error.status)) {
                case 403:
                  self.loading = "";
                  if(error.data.code == 'ERROR_UNAUTHORIZE'){
                    self.$storeIndex.popupAccessDenied(self);
                  }else if(error.data.code == 'ERROR_FEATURE_NOT_ALLOWED'){
                    self.$storeIndex.alertNotFeature(self);
                  }
                  break;
                default:
                  self.$storeIndex.toastAlert('error', 'Failed', 'Resend Email Confirm Failed.', self);
                  break;
              }
            }
          },
        }).then(async (result) => {
          if(viewAction){
            self.$refs.close.click();

            if (actionPage == 'entry' && result.isConfirmed) {
              self.$nextTick(() => {
                self.$parent.$refs.vuetable.refresh();
              });
            }
          }else{
            self.clearBulkActions();
            if (actionPage == 'entry' && result.isConfirmed) {
              self.$nextTick(() => {
                self.$refs.vuetable.refresh();
              });
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
      
    },
    async confirmEntries(ids, self, viewAction = false, actionPage = 'entry') {
      const Swal = self.$swal;
      try {
        const tryAgainText = self.$t("Try again");
        const accessDeniedHtml = self.$t("Access Denied");
        let title = self.$t("Mark As Confirm")+' ?';
        let html = self.$t("You will not be able to undo this action.");
        let confirmButtonText = '<i class="fas fa-check-circle mr-1"></i> ' + self.$t("Confirm");

        let formId = self.$route.params.id;
        let data = {
            submit_ids : ids
          }
        Swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: self.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            confirmButtonText = '<i class="fa-solid fa-rotate-right"></i> ' + tryAgainText;
            try {
              const response = await Api.ToolV2.putConfirmEntries(formId, data);
              if(response.status != 200 && response.status != 201){
                throw response
              }
              self.$storeIndex.toastAlert('success', 'Success', 'Mark As Confirm Success.', self);
            } catch (error) {
              switch (Number(error.status)) {
                case 403:
                  self.loading = "";
                  if(error.data.code == 'ERROR_UNAUTHORIZE'){
                    self.$storeIndex.popupAccessDenied(self);
                  }else if(error.data.code == 'ERROR_FEATURE_NOT_ALLOWED'){
                    self.$storeIndex.alertNotFeature(self);
                  }
                  break;
                default:
                  self.$storeIndex.toastAlert('error', 'Failed', 'Mark As Confirm Failed.', self);
                  break;
              }
            }
          },
        }).then(async (result) => {
          if(viewAction){
            self.$refs.close.click();

            if (actionPage == 'entry' && result.isConfirmed) {
              self.$nextTick(() => {
                self.$parent.$refs.vuetable.refresh();
              });
            }
          }else{
            self.clearBulkActions();

            if (actionPage == 'entry' && result.isConfirmed) {

              self.$nextTick(() => {
                self.$refs.vuetable.refresh();
              });
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
      
    },
    async rejectEntries(ids, self, viewAction = false, actionPage = 'entry') {
      const Swal = self.$swal;
      try {
        const tryAgainText = self.$t("Try again");
        const accessDeniedHtml = self.$t("Access Denied");
        let title = self.$t("Mark As Reject")+' ?';
        let html = self.$t("You will not be able to undo this action.");
        let confirmButtonText = '<i class="fas fa-check-circle mr-1"></i> ' + self.$t("Confirm");

        let formId = self.$route.params.id;
        let data = {
            submit_ids : ids
          }
        Swal({
            icon: "warning",
            iconColor: "#FF7043",
            title: title,
            html: html,
            showCancelButton: true,
            cancelButtonText: self.$t("Cancel"),
            confirmButtonText: confirmButtonText,
            buttonsStyling: false,
            customClass: {
                confirmButton: "btn btn-primary mr-2",
                cancelButton: "btn btn-light",
            },
            focusConfirm: false,
            showLoaderOnConfirm: true,
            preConfirm: async function () {
              confirmButtonText = '<i class="fa-solid fa-rotate-right"></i> ' + tryAgainText;
              try {
                const response = await Api.ToolV2.putRejectEntries(formId, data);
                if(response.status != 200 && response.status != 201){
                  throw response
                }
                self.$storeIndex.toastAlert('success', 'Success', 'Mark As Reject Success.', self);
              } catch (error) {
                switch (Number(error.status)) {
                  case 403:
                    self.loading = "";
                    if(error.data.code == 'ERROR_UNAUTHORIZE'){
                      self.$storeIndex.popupAccessDenied(self);
                    }else if(error.data.code == 'ERROR_FEATURE_NOT_ALLOWED'){
                      self.$storeIndex.alertNotFeature(self);
                    }
                    break;
                  default:
                    self.$storeIndex.toastAlert('error', 'Failed', 'Mark As Reject Failed.', self);
                    break;
                }
              }
            },
        }).then(async (result) => {
          if(viewAction){
            self.$refs.close.click();

            if (actionPage == 'entry' && result.isConfirmed) {
              self.$nextTick(() => {
                self.$parent.$refs.vuetable.refresh();
              });
            }
          }else{
            self.clearBulkActions();

            if (actionPage == 'entry' && result.isConfirmed) {

              self.$nextTick(() => {
                self.$refs.vuetable.refresh();
              });
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },  
    async confirmRemoveFile(self, index, done, fileList, mediaId = null){
      await self.$swal.fire({
          icon: "warning",
          iconColor: "#FF7043",
          title: self.$t("Delete Attachment ?"),
          html: self.$t("You will not be able to undo this action."),
          showCancelButton: true,
          cancelButtonText: self.$t("Cancel"),
          confirmButtonText: '<i class="fas fa-check-circle mr-1"></i>' + self.$t("Confirm"),
          buttonsStyling: false,
          customClass: {
              confirmButton: "btn btn-primary mr-2",
              cancelButton: "btn btn-light",
          },
          focusConfirm: false,
      }).then((result) => {
          if (result.isConfirmed) {
              self.callBackRemoveFile(true, index, done, fileList, mediaId);
          } else {
              self.callBackRemoveFile(false, index, done, fileList, mediaId);
          }
      });
    },
    getCheckCy(){ 
      console.log('getCheckCy = ',window.Cypress)
      if (window.Cypress) {
        console.log('getCheckCy if = ',window.Cypress)
        return true
      }
      return false
    },
};




// WEBPACK FOOTER //
// ./src/store/index.js